import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg04.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Unlock Your Potential With The Top Denver App Development Agency
              </h2>
            </div>
            <p>
              As a leading mobile app development company in Denver, we offer
              incomparable digital solutions for your business's success.
              Drawing on our knowledge within the dynamic North American tech
              arena and yielding leading-edge digital solutions, our goal is to
              boost your business towards unprecedented heights. Our
              comprehensive mobile and web app development services bring
              forward efficient solutions personalized to achieve your goals.
              Supported by our knowledge, your business is composed to
              experience the digital transformation required for booming
              success.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
